import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from './lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

/**
 * Two variants:
 *
 * variant="default"  — dark navy background, white text.
 *                      Used for icon-button labels ("Expand", "Customize").
 *
 * variant="info"     — light surface background, bordered, slightly wider.
 *                      Used for ⓘ hover on KPI labels and metric descriptions.
 *
 * Font is 10.5px / weight 500 for visual consistency.
 * Max width defaults to 180px to stay within card bounds.
 */
const VARIANT = {
  default: 'bg-navy text-text-primary shadow-md',
  info:    'bg-nn-white text-text-dark border border-nn-border shadow-card',
};

const TooltipContent = React.forwardRef(
  ({ className, variant = 'default', sideOffset = 6, maxWidth = 180, ...props }, ref) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        style={{ maxWidth, fontSize: '10.5px', fontWeight: 500 }}
        className={cn(
          'z-tooltip overflow-hidden rounded px-2 py-[3px]',
          'leading-snug',
          'animate-fade-in',
          VARIANT[variant] ?? VARIANT.default,
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
